import React from 'react';
import styled from 'styled-components';
//para importar imagenes en svg
import {ReactComponent as Puntos} from './../imagenes/puntos.svg';


const Svg = styled.svg`
    height: 50vh;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 0;
    path {
        fill: rgba(135,182,194, .15);
    }
`;
 
const PuntosArriba = styled(Puntos)`
    position: fixed;
    z-index: 1;
    top: 2.5rem; /* 40px */
    left: 2.5rem; /* 40px */
`;
 
const PuntosAbajo = styled(Puntos)`
    position: fixed;
    z-index: 1;
    bottom: 2.5rem; /* 40px */
    right: 2.5rem; /* 40px */
`;

const Fondo = () => {
    return ( 
        <>
            <PuntosArriba />
            <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
                <path 
                    //fill="#0099ff" 
                    fillOpacity="1" 
                    d="M0,64L48,101.3C96,139,192,213,288,218.7C384,224,480,160,576,117.3C672,75,768,53,864,37.3C960,21,1056,11,1152,58.7C1248,107,1344,213,1392,266.7L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </Svg>
            <PuntosAbajo />
        </>
     );
}
 
export default Fondo;